// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { chartDiagramChildFocus16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-chart-diagram-child-focus': IconChartDiagramChildFocus;
    }
}

/**
 * The icon component for the 'chartDiagramChildFocus' icon
 */
export class IconChartDiagramChildFocus extends Icon {
    public constructor() {
        super(chartDiagramChildFocus16X16);
    }
}

registerIcon('icon-chart-diagram-child-focus', IconChartDiagramChildFocus);
export const iconChartDiagramChildFocusTag = 'nimble-icon-chart-diagram-child-focus';
